import { render, staticRenderFns } from "./LicensesManage.vue?vue&type=template&id=1272cbf1"
import script from "./LicensesManage.vue?vue&type=script&lang=js"
export * from "./LicensesManage.vue?vue&type=script&lang=js"
import style0 from "./LicensesManage.vue?vue&type=style&index=0&id=1272cbf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports